import React from 'react';

const LandingLayout = ({ children }) => (
  <div className="min-h-screen bg-background text-text-primary">
    {children}
  </div>
);

export default LandingLayout;
